import { render } from "./terms-modal.vue?vue&type=template&id=3c378561"
import script from "./terms-modal.vue?vue&type=script&lang=js"
export * from "./terms-modal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__